import React, { Component } from 'react';
import './KnowledgePanel.css';
import Markdown from 'react-markdown';

export const id = 'knowledgePanel';

class KnowledgePanel extends Component {
  render() {

    const knowledge = `
| What languages do I know? | What tech do I have experience in? |
| --- | --- |
| C++ and STL | Object-Oriented Programming (OOP) |
| Objective-C, Cocoa | Xcode |
| Ruby | Object Oriented Design |
| Python | Agile and Scrum |
| JavaScript | OS X |
| React | Design Patterns |
| React Native | Fastlane |
| Bash | iOS development |
| Groovy | Visual Studio |
| Pascal | Perforce |
| HTML | Interface Builder |
| jQuery | Gradle |
| | Ansible and Jinja |
| | Git, Github, and Gitlab |
| | CodeWarrior |
| | Multithreading |
| | Win32 |
| | JIRA |

  `

    const education = `
### Education

#### University of Saskatchewan: Bachelors of Computational Science
  
### Activities and Societies: 

- Spectrum Tradeshow 1995
- Worked at the Computer Lab as a Lab Assistant.
- Worked at the Campus Computer Store during university.
    `
    const knowledgeContainerClassname = this.props.isMobile ?
      'MobileKnowledgeContainer' :
      'KnowledgeContainer';
    return (
      <div className="KnowledgePanel" id={id}>
        <div className="KnowledgePanelBlurb">
          <div id="KnowledgeContainer" className={knowledgeContainerClassname}>
            <h2>What are some of the things I know?</h2>
            <p />
            <Markdown source={knowledge} />
            <Markdown source={education} />
          </div>
        </div>
      </div>
    );
  }
}

export default KnowledgePanel;



// WEBPACK FOOTER //
// ./src/KnowledgePanel.js